import { useEffect, useRef } from "react";
import { toast } from "@volca/ui/lib/toast";
import type { PayrollEditorQueries } from "@/payroll/editor/query";
import type { EnrichedQueuedUpload } from "@/payroll/editor/types";
import { enrichAttachments } from "./enrich-attachments";

export const useAttachmentErrorToasts = (
  storageKey: string,
  documents: PayrollEditorQueries["documents"],
  uploads: EnrichedQueuedUpload[],
) => {
  const previous = useRef<{
    key: string;
    errors: Map<string, string>;
  } | null>(null);

  useEffect(() => {
    if (!documents.isSuccess) return;
    const files = enrichAttachments(documents.data ?? [], uploads, {});
    const errors = new Map(
      files.flatMap((file) => (file.error ? [[file.id, file.error]] : [])),
    );
    // Existing failures remain on the tiles. Notify only when a file fails
    // during this visit, rather than on each poll or when a proposal opens.
    if (previous.current?.key === storageKey) {
      for (const file of files) {
        if (file.error && previous.current.errors.get(file.id) !== file.error)
          toast.error(`Could not read ${file.name}`, {
            description: file.error,
          });
      }
    }
    previous.current = { key: storageKey, errors };
  }, [storageKey, documents.data, documents.isSuccess, uploads]);
};
